import { createSlice } from "@reduxjs/toolkit"
import { TaskGet } from "../../types/Types"
import { getTemplates } from "../../../../entities/Templates/model/templateThunk"

type TemplateTaskInit = {
    entities: {
        tasks: TaskGet[],
        hasNextPage: boolean,
        pageIndex: number,
        totalCount: number,
        totalPages: number
    },
    isLoading: boolean,
    error: string | null,
}

export const initialStateTemplate: TemplateTaskInit = {
    entities: {
        tasks: [],
        hasNextPage: true,
        pageIndex: 1,
        totalCount: 0,
        totalPages: 0
    },
    isLoading: true,
    error: null,
}

export const templateTaskSlice = createSlice({
    name: 'templatetask',
    initialState: initialStateTemplate,
    selectors: {
        selectTemplatesTask: (state) => state.entities.tasks,
        selectTemplatesTaskById: (state, id: number) => state.entities.tasks.find((el) => el.id === id) 
    },
    reducers: {
        clearTasks: (state) => {
            state.entities.tasks = [];
            state.entities.hasNextPage = true;
          },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTemplates.pending, (state) => {
                state.isLoading = true;
                state.error = null
            })
            .addCase(getTemplates.fulfilled, (state, action) => {
                state.isLoading = false;
                const { data, page } = action.payload;

                if (page === 1) {
                    state.entities = data;
                } else {
                    state.entities.tasks.push(...data.tasks);
                }

                if (data.tasks.length < 10) {
                    state.entities.hasNextPage = false;
                }
            })
            .addCase(getTemplates.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || 'Что-то пошло не так...'
            })
    }
})

export const { clearTasks } = templateTaskSlice.actions;
export default templateTaskSlice.reducer;